import React from "react";

export default function BecauseScienceFooter({
    title = "BecauseScience",
    blurb = "BecauseScience.cool is a monthly digital publication that tells immersive, multimedia stories of science and discovery as they apply to modern life.",
    poweredBy = "Powered by Arizona State University",
    bgClass = "bg-[#efb6c2]",         // fallback solid color
    textClass = "text-slate-900",
    bgImage = null,
    bgSize = "cover",
    bgPosition = "center",
    bgOverlay = false,
}) {
    return (
        <footer
            className={`${bgClass} ${textClass} w-full relative overflow-hidden`}
            style={
                bgImage
                    ? {
                        backgroundImage: `url('${bgImage}')`,
                        backgroundSize: bgSize,
                        backgroundPosition: bgPosition,
                        backgroundRepeat: "no-repeat",
                    }
                    : {}
            }
        >
            {/* Optional overlay (for contrast on bright/dark images) */}
            {bgOverlay && (
                <div className="absolute inset-0 bg-black opacity-40 pointer-events-none" />
            )}

            <div className="relative w-full px-6 sm:px-14 py-10 sm:py-24 z-10">
                {/* Big title */}
                <h2 className="font-serif tracking-tight text-[40px] sm:text-6xl md:text-7xl">
                    {title}
                </h2>

                {/* Bottom row: blurb left, powered by right */}
                <div className="mt-6 flex flex-col sm:flex-row justify-between gap-6 w-full">
                    <p className="max-w-md text-[11px] sm:text-xs leading-relaxed opacity-90">
                        {blurb}
                    </p>
                    <p className="text-[10px] sm:text-xs font-medium opacity-90 self-start sm:self-end">
                        {poweredBy}
                    </p>
                </div>
            </div>
        </footer>
    );
}
